import { deliveryMenus } from "./menus";
import { importMenu } from "./import-menu";
import { deliverySettings } from "./settings";
import { deliveryReport } from "./report";
import { syncMenu } from "./sync-menu";

export const delivery = {
	goBack: "Volver",
	updateManyExternalIntegrations: {
		success: "Integraciones actualizadas con éxito",
	},
	externalStoreIntegrationStatus: {
		synced: "Sincronizado",
		pendingSyncing: "Sincronización pendiente",
		pendingImporting: "Importación pendiente",
	},
	ordersManager: {
		title: "Gestor de pedidos",
		description:
			"Rastrea y gestiona los pedidos que llegan de Entregue já, Comanda Online y Pedido na mesa.",
		filter: {
			placeholder: "Filtrar por",
		},
		tabs: {
			newOrders: "Nuevos Pedidos",
			inDelivery: "En Entrega",
			completed: "Concluidos",
		},
		createOrder: "Crear nuevo pedido",
		loading: "Cargando",
		total: "Total: {{value}}",
		new: "Nuevo",
		emptyState: {
			title: "Aún no tenemos pedidos {{status}}.",
			description: "Aquí mostraremos cuando recibas nuevos pedidos.",
		},
		immersion: {
			enter: "Inmersión",
			exit: "Salir de inmersión",
		},
		sound: {
			on: "Sonido activado",
			off: "Sonido silenciado",
		},
		whatsNew: {
			intro: {
				title: "¡Tenemos novedades por aquí! 🎉",
				description:
					"Actualizamos el Gestor de pedidos. ¿Quieres ver rápido lo que cambió?",
				start: "Ver novedades",
			},
			step: "Paso {{current}} de {{total}}",
			next: "Siguiente",
			finish: "Entendido",
			skip: "Omitir",
			test: "Reproducir sonido de ejemplo",
			immersion: {
				title: "Nuevo: Modo inmersión",
				description:
					"Pon el gestor en pantalla completa, sin menús, ideal para usar en el mostrador.",
			},
			sound: {
				title: "Nuevo: Sonido de pedido nuevo",
				description:
					"Reproducimos una alerta sonora cuando llega un pedido nuevo. Usa el botón para activarlo o silenciarlo.",
			},
		},
	},
	deliverySettings,
	deliveryReport,
	deliveryMenus,
	syncMenu,
	importMenu,
};
